goog.provide("shadow.js.shim.module$src$svg$objects$automagic_svg");
goog.provide("module$shadow_js_shim_module$src$svg$objects$automagic_svg");
shadow.js.shim.module$src$svg$objects$automagic_svg = shadow.js.nativeProvides["src/svg/objects/automagic.svg"] = shadow$bridge("src/svg/objects/automagic.svg");
module$shadow_js_shim_module$src$svg$objects$automagic_svg.default = shadow.js.shim.module$src$svg$objects$automagic_svg;
